/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;height:100%;padding-top:109px}[_nghost-%COMP%]   .container[_ngcontent-%COMP%]{margin-top:5.14285714rem;max-width:73.14285714rem}"];
export { styles as styles };
